import { Table } from 'antd';
import React, { useEffect, useState } from 'react';
import { sortString } from '@nephro/commons/helpers/utils';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import useFormatDate from 'hook/useFormatDate';

const PatientMassiveProcessingByIdColumns = (translate) => {
  return [
    {
      title: translate('patientMg.name'),
      dataIndex: 'name',
      sorter: sortString('name')
    },
    {
      title: translate('patientMg.lastName'),
      dataIndex: 'lastName',
      sorter: sortString('lastName')
    },
    {
      title: translate('patientMg.email'),
      dataIndex: 'email',
      sorter: sortString('email')
    },
    {
      title: translate('patientMg.phoneNumber'),
      dataIndex: 'phoneNumber',
      sorter: sortString('phoneNumber')
    },
    {
      title: translate('patientMg.patient_status'),
      dataIndex: 'patient_status',
      sorter: sortString('patient_status')
    },
    {
      title: translate('patientMg.process_date'),
      dataIndex: 'process_date',
      sorter: sortString('process_date')
    }
  ];
};

function PatientsMassiveProcessingById({ patientActions }) {
  const { t: translate } = useTranslation();
  const { id } = useParams();
  const { patientMProcessDetail } = patientActions;

  const [rows, setRows] = useState([]);
  const columns = PatientMassiveProcessingByIdColumns(translate);
  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (id) {
      patientMProcessDetail(id, (message, res) => {
        if (message === 'success') {
          const cleanPatients = res.data.map((patient) => {
            return {
              name: patient.patient_names,
              lastName: patient.patient_secnames,
              email: patient.patient_email,
              phoneNumber: patient.patient_phone,
              patient_status: patient.patient_mprocess_status.description,
              process_date: useFormatDate(patient.processing_time, true)
            };
          });

          setRows(cleanPatients);
        }
      });
    }
  }, [id]);

  const isVirtualPagination = true;

  const onChangePagination = () => {};

  const onChange = () => {};

  return (
    <div>
      <div className="h-full mt-20">
        <div className="flex flex-wrap">
          <div className="w-full overflow-x-scroll">
            <Table
              bordered={false}
              columns={columns}
              dataSource={rows}
              size="small"
              scroll={{ x: true }}
              rowKey={(record, i) => `${record.documento}-${i}`}
              onChange={isVirtualPagination ? onChangePagination : onChange}
              pagination={
                isVirtualPagination
                  ? {
                      position: ['bottomCenter'],
                      showSizeChanger: false,
                      hideOnSinglePage: true
                    }
                  : false
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
}

PatientsMassiveProcessingById.propTypes = {
  actions: PropTypes.shape({
    setLoading: PropTypes.func.isRequired
  }),
  authActions: PropTypes.shape({
    recoverPassword: PropTypes.func.isRequired
  }).isRequired,
  patientActions: PropTypes.shape({
    patientMProcessDetail: PropTypes.func.isRequired
  }).isRequired,
  dashboardStaffActions: PropTypes.shape({
    getAdmonCodesByEntity: PropTypes.func.isRequired
  }).isRequired,
  clinicId: PropTypes.string,
  lastVersiaUpdate: PropTypes.string,
  clinics: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]).isRequired,
  insurers: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]).isRequired,
  user: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]).isRequired
};

export default PatientsMassiveProcessingById;
